const getCategoryTreatments = state => state.category.treatments;

export default getCategoryTreatments;
